import { Typography, Grid } from "@mui/material";
import { photosApi } from "../../SourceData";
import Loader from "../../components/Loader/Loader";

const DepartmentSelection = ({ departments, loading, language, onDepartmentSelect }) => {
  return (
    <div className="departments-container">
      <div className="worker-search-header">
        <Typography variant="h5" component="h2" className="search-title">
          {language === "ar" ? "اختر القسم" : "Choose Department"}
        </Typography>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <Grid container spacing={3}>
          {departments.map((department) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={4}
              className="department-grid-item"
              key={department._id}
            >
              <div
                className="department-circle"
                onClick={() => onDepartmentSelect(department)}
              >
                <div className="circle-icon">
                  <img
                    src={photosApi + department.photo}
                    alt={department.name[language]}
                    className="department-image"
                  />
                </div>
                <Typography variant="subtitle1" className="department-name">
                  {department.name[language]}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default DepartmentSelection;